import { Pipe, PipeTransform, SecurityContext } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

@Pipe({
  name: 'joinArray'
})
export class JoinArrayPipe implements PipeTransform {

  constructor(private domSanitizer: DomSanitizer) { }

  transform(arrObj: any[], separator: string, propName?: string): any {
    if (typeof (arrObj) === 'string') {
      return arrObj;
    }

    if (!arrObj || (arrObj instanceof Array && (!arrObj.length || !separator))) {
      return '';
    }

    let joinedString: string = '';
    if (!!propName) {
      joinedString = arrObj.map(x => x[propName]).join(separator);
    } else {
      joinedString = arrObj.join(separator);
    }
    return this.domSanitizer.sanitize(SecurityContext.HTML, joinedString);
  }

}
